/**
 * Shared option constants for filter fields that both
 * `contacts-filters.types.ts` and `filterable-fields.ts` need.
 *
 * Deliberately dependency-free: `filterable-fields.ts` imports
 * `GENDER_OPTIONS`/`LANGUAGE_OPTIONS`/`META_TAG_OPTIONS` to build
 * `FILTERABLE_FIELDS`, and `contacts-filters.types.ts` imports
 * `FILTERABLE_FIELDS` from `filterable-fields.ts`. If these constants lived
 * in `contacts-filters.types.ts` (as they used to), that would form a
 * circular module dependency and crash at module-load time. Keeping them
 * here, with no imports of its own, breaks the cycle while keeping a single
 * source of truth. `contacts-filters.types.ts` re-exports these so existing
 * consumers that import them from there keep working unchanged.
 */

export const GENDER_OPTIONS = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
] as const;

export const LANGUAGE_OPTIONS = [
  { value: 'en-US', label: 'English' },
  { value: 'de-DE', label: 'German' },
  { value: 'fr-FR', label: 'French' },
] as const;

export const META_TAG_OPTIONS = [
  'Bern',
  'luzern',
  'Family Zurich',
  'mock-data',
] as const;
